export default {"src":"/_next/static/media/api-service.4f673fb9.svg","height":1080,"width":1920,"blurWidth":0,"blurHeight":0};